import i18n from "config/i18n/i18n";
import { routers } from "config/routes";
import dayjs from "dayjs";
import dayjsBusinessDays from "dayjs-business-days2";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

// Order matters: neonumy-ui's :root vars (gold palette) must load before
// styles.less, whose :root override (blue palette) needs to win the cascade.
import { NotificationProvider, ThemeProvider } from "@neonumy/neonumy-ui";
import "@neonumy/neonumy-ui/lib/index.css";
import "./resources/styles/styles.less";

dayjs.extend(dayjsBusinessDays);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(utc);

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      {/* Also configures the app's own `antd5` imports: it sets prefixCls
          "ant5", which keeps v5 markup out of reach of the v4 stylesheet. */}
      <ThemeProvider>
        <NotificationProvider>
          <RouterProvider router={routers} />
        </NotificationProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}
